// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_ToggleActiveResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/devices_franquias/toggle_active
 *
 * Action endpoint — emits a confirmation message reflecting the new active
 * state (activated/deactivated).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface DevicesFranquias_ToggleActiveResponseDados {
message: string
}

export type DevicesFranquias_ToggleActiveResponse = ApiResponse<DevicesFranquias_ToggleActiveResponseDados>;

registerResponseContract('DevicesFranquias_ToggleActiveResponse', {
  message: { type: 'string',  required: true },
})
